export default __webpack_public_path__ + "static/media/si.b334c1a8.svg";